import { FormBase } from 'core/components';

export default class AssignCarrierAccountForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'carrierId',
					label: 'ASSIGNCARRIERACCOUNTVIEW.CARRIERID',
				},
			],
		};
	}
}
